export interface EpicSettingsReference {
    time: Array<number>;
    description: string;
    activity: string;
}

export function EpicSettingsReferenceFromJSON(json: any): EpicSettingsReference {
    return {
        time: (json["time"] as Array<number>),
        description: json["description"],
        activity: json["activity"],
    };
}
